import { generatePath, ParamParseKey, Path } from 'react-router-dom';

import { authPaths } from './auth';
import { disclosurePaths } from './disclosure';
import { messagingPaths } from './messaging';
import { newConversationPaths } from './newConversation';
import { restPaths } from './rest';
import { surveyPaths } from './survey';

const paths = [
    ...authPaths,
    ...disclosurePaths,
    ...surveyPaths,
    ...messagingPaths,
    ...newConversationPaths,
    ...restPaths,
];

export type Paths = (typeof paths)[number];
type ParamsType = { [key in ParamParseKey<Paths>]: string };

export interface GetPathOptions {
    params?: Partial<Omit<ParamsType, '*'>>;
    path: Paths | (Partial<Path> & { pathname: Paths });
}

export const getPath = ({ params, path }: GetPathOptions) => {
    const isSimplePath = typeof path === 'string';
    const pathname = isSimplePath ? path : path.pathname;

    let pathExtensions = '';
    if (!isSimplePath) {
        if (!!path.search)
            pathExtensions += path.search.startsWith('?')
                ? path.search
                : `?${path.search}`;

        if (!!path.hash)
            pathExtensions += path.hash.startsWith('#')
                ? path.hash
                : `#${path.hash}`;
    }

    return generatePath(pathname, params as ParamsType) + pathExtensions;
};
